import * as yup from 'yup';

import i18n from '@src/app/i18n/config';
import { onlyNumbers } from '@src/shared/regexps';

export const agentAddressSchema = yup
  .object()
  .shape({
    region: yup.string().required(i18n.t('AGENT_ADDRESS:errors.specifyRegion')),
    city: yup.string().required(i18n.t('AGENT_ADDRESS:errors.specifyCity')),
    street: yup.string(),
    house: yup.string().required(i18n.t('AGENT_ADDRESS:errors.specifyHouse')),
    flat: yup
      .string()
      .matches(onlyNumbers, i18n.t('AGENT_ADDRESS:errors.specifyFlat')),
    isActualAddressMatchRegistration: yup.boolean(),
  })
  .required();
